module.exports = __webpack_public_path__ + "img/744.f30ee9f3.jpg";